import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/seller-market-product-order-item/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Seller Market Product Order Item `status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} confirm_price_status Seller Product price confirm status. available values
 */
const SellerMarketProductOrderItemStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.CUSTOMER_PAID]    : 'warning',
    [STATUS.SELLER_CANCELLED] : 'danger',
    [STATUS.SELLER_SHIPPED]   : 'info',
    [STATUS.OPS_RECEIVED]     : 'info',
    [STATUS.OPS_REJECTED]     : 'danger',
    [STATUS.OPS_ACCEPTED]     : 'success',
    [STATUS.EXPIRED]          : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

SellerMarketProductOrderItemStatusBadge.propTypes = proptypes

export default SellerMarketProductOrderItemStatusBadge
